import iziToast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';

import getDessertById from '../api-requests/getDessertById.js';

import {
  openDessertModal,
  closeDessertModal,
  renderDessertModalContent,
  getModalRoot,
} from './dessert-details-modal.js';

const getToastWidth = () => {
  if (window.matchMedia('(max-width: 374px)').matches) {
    return window.innerWidth - 32;
  }

  if (window.matchMedia('(max-width: 767px)').matches) {
    return 335;
  }

  return 640;
};

export const onOpenDessertModalClick = async event => {
  const openModalBtn = event.target.closest('.js-dessert-modal-open');

  if (!openModalBtn) {
    return;
  }

  const dessertId = openModalBtn.dataset.id;

  if (!dessertId) {
    iziToast.error({
      message: 'Не вдалося визначити десерт. Спробуйте ще раз.',
      position: 'topRight',
      color: '#F5B6B6',
      messageColor: '#000000',
      class: 'custom-toast',
      maxWidth: getToastWidth(),
    });

    return;
  }

  openDessertModal();

  try {
    const dessert = await getDessertById(dessertId);
    renderDessertModalContent(dessert);
  } catch (error) {
    closeDessertModal();

    iziToast.error({
      message: 'Не вдалося завантажити інформацію про десерт. Спробуйте ще раз.',
      position: 'topRight',
      color: '#FFC9C9',
      messageColor: '#000000',
      class: 'custom-toast',
      maxWidth: getToastWidth(),
    });

    console.log(error);
  }
};

export const onBackdropClick = event => {
  const modalRoot = getModalRoot();

  if (event.target === modalRoot) {
    closeDessertModal();
  }
};

export const onEscKeydown = event => {
  if (event.key === 'Escape') {
    closeDessertModal();
  }
};

export const onCloseBtnClick = () => {
  closeDessertModal();
};

export const onOrderBtnClick = event => {
  const dessertId = event.currentTarget.dataset.dessertId;

  closeDessertModal();

  const orderModalOpenEvent = new CustomEvent('open-order-modal', {
    detail: { dessertId },
  });

  document.dispatchEvent(orderModalOpenEvent);
};